import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface PlaylistDetailsCSSStyle extends CRBTUICSSStyle
{
    getPlaylistDetailsTextCSSStyle(): object;
    getSubscribeCSSStyle(): object;
    getToneImgDivCSSStyle(): object;
    getToneDetailsDivCSSStyle(): object;
    getToneNameCSSStyle(): object;
    getArtistNameCSSStyle(): object;
}

export class PlaylistDetailsCSSStyleImpl extends CRBTUICSSStyleImpl implements PlaylistDetailsCSSStyle
{
    getWrapperCSSStyle()
    {
        return{
            width: "100%",
            textAlign: "center"
        };
    }

    getToneImgDivCSSStyle(): object 
    {
        return {
            height: "200px",
            // width: "170px",
            borderRadius:'8px',
            position: "relative",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            margin: "0 auto"
        };
    }

    getToneDetailsDivCSSStyle(): object 
    {
        return {
            paddingTop: "20px",
            paddingLeft:'20px',
            paddingRight:'20px',
            height: "80px",
            width: "100%",
            backgroundColor: this.getResources().getColor(Colors.color_5),
        };
    }

    getToneNameCSSStyle(): object {
       return {
        width: "100%",
        height: "30px",
        minWidth:'50px',
        fontWeight: "900",
        letterSpacing: 0,
        fontFamily: this.getResources().getFontFamily(),
        fontSize: this.getResources().getFont(Fonts.h12),
        color:this.getResources().getColor(Colors.color_6),
        lineHeight: "30px",
        textAlign: "center",
        overflow: 'hidden',
        textOverflow: 'ellipsis'
       };
    }

    getArtistNameCSSStyle(): object {
        return {
            width: "100%",
            minWidth:'50px',
            height: "20px",
            fontFamily: this.getResources().getFontFamily(),
            color:this.getResources().getColor(Colors.color_7),
            fontSize: this.getResources().getFont(Fonts.h9),
            letterSpacing: 0,
            lineHeight: "20px",
            textAlign: "center",
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        };
    }

    getPlaylistDetailsTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h11),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "30px",
            width: "100%",
            marginTop: "40px",
            textAlign: "center",
        };
    }
    
    getSubscribeCSSStyle(): object 
    {
        return{
           width: "180px",
            display: "inline-block",
            marginTop: "30px",
            margin: "0 !important",
            marginBottom:'30px',

        };
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/playlistdetailscss.tsx